import { CheckCircle2 } from "lucide-react";
import { useState } from "react";
import { useAuth } from "../../auth/AuthProvider";
import { Button } from "../../components/ui";
import { useErpData } from "../../data/DataProvider";
import type { Booking } from "../../data/types";

/**
 * Confirms from the panel that the money of a WooCommerce order arrived (a transfer, usually).
 * WordPress marks the order paid, as "Procesando" does in WooCommerce, and confirms the booking.
 */
export function ConfirmOrderPayment({ booking, orderId, amountLabel, onDone }: {
  booking: Booking;
  orderId?: number | undefined;
  amountLabel?: string | undefined;
  onDone: () => void;
}) {
  const { executeCommand } = useErpData();
  const { hasPermission } = useAuth();
  const [asking, setAsking] = useState(false);
  const [working, setWorking] = useState(false);
  const [feedback, setFeedback] = useState("");
  if (!hasPermission("bookings.record_payment")) return null;
  const confirm = async () => {
    setWorking(true);
    setFeedback("");
    try {
      await executeCommand({
        type: "booking.confirm_order_payment",
        aggregateId: booking.id,
        expectedVersion: booking.version,
        payload: orderId ? { order_id: orderId } : {},
      });
      setAsking(false);
      setFeedback("Pago confirmado. La reserva queda pagada.");
      onDone();
    } catch (caught) {
      setFeedback(caught instanceof Error ? caught.message : "No se pudo confirmar el pago.");
    } finally {
      setWorking(false);
    }
  };
  return (
    <div className="confirm-order-payment">
      {!asking ? (
        <Button icon={CheckCircle2} onClick={() => setAsking(true)}>
          Confirmar pago recibido
        </Button>
      ) : (
        <div className="confirm-order-payment__ask" role="group" aria-label="Confirmar pago">
          <p>¿Ya viste {amountLabel ? `el depósito de ${amountLabel}` : "el depósito"} en tu cuenta? El pedido queda pagado y la reserva confirmada.</p>
          <Button icon={CheckCircle2} disabled={working} onClick={() => void confirm()}>
            {working ? "Confirmando…" : "Sí, ya lo recibí"}
          </Button>
          <Button variant="quiet" disabled={working} onClick={() => setAsking(false)}>
            Cancelar
          </Button>
        </div>
      )}
      {feedback && <p className="quote-feedback" role="status">{feedback}</p>}
    </div>
  );
}
